import React from 'react';
import { Image, Source } from '@unpic/react';
import { IProductGalleryImage } from '../../../types/product/productDetailPage';
import DefaultVideoImage from './DefaultVideo';

interface VideoAssetImageProps {
  image?: IProductGalleryImage;
  video?: string;
  position: number;
}

const VideoAssetImage = ({ image, video, position }: VideoAssetImageProps) => {
  if (!image) return <DefaultVideoImage video={video} />;
  return (
    <picture key={`gallery-img-${image.url}`} data-zoom={image.url}>
      {['avif', 'webp', null].map((format) => (
        <Source
          key={`gallery-img-${format || 'default'}`}
          type={format && `image/${format}`}
          src={image.url}
          layout="fullWidth"
          breakpoints={[150, 260, 450, 740]}
        />
      ))}
      <Image
        priority={position === 0}
        alt={image.title}
        src={image.url}
        breakpoints={[150, 260, 450, 740]}
        layout="fullWidth"
        className="pd-cover-parent"
      />
    </picture>
  );
};

export default VideoAssetImage;
